document.addEventListener('click', (event) => {
  const back = event.target.closest('[data-piercing-back]');
  if (!back) return;
  const group = back.closest('.rk-piercing-group');
  group.open = false;
  group.querySelector('summary').setAttribute('aria-expanded', 'false');
  group.querySelector('summary').focus();
});
document.addEventListener('toggle', (event) => {
  const group = event.target;
  if (!(group instanceof HTMLDetailsElement) || !group.matches('.rk-piercing-group')) return;
  if (group.closest('header-drawer')) return;
  group.querySelector('summary').setAttribute('aria-expanded', String(group.open));
  if (group.open) group.querySelector('[data-piercing-back]').focus();
}, true);
